import SimpleConfirmDialog from "components/Global/ConfirmationDialogs/SimpleConfirmDialog";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { Button, Grid, TableCell } from "@material-ui/core";
import React, { Component, Fragment } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import { getAllGuests } from "store/state/guest";
import { getGuestGroupById, updateGuestGroup } from "store/state/guestGroup";
import { EnhancedTable } from "components/Global/Table/EnhancedTable";
import { AddGuestGroupMembersModal } from "../Modals/AddGuestGroupMembersModal";

const NewButton = styled(Button)`
  && {
    margin: 0 0 -4px 4px;
    padding: 8px 8px 0px 2px;
    border-radius: 0;
    color: #2196f3;
    background: none;
  }
  & span {
    margin-left: 4px;
  }
  &&:hover {
    background: #f6f6f6;
  }
`;

const HeaderLeftContainer = styled(Grid)`
  max-width:calc(100% - 250px) !important;
`;

class GuestPermissionsPage extends Component {
  constructor(props) {
    super(props);
    this.props.getAllGuests({ includeAuxData: true });
    this.props.getGuestGroupById({ id: this.props.match.params.guestGroupId });
    this.state = {
      showAddMembersModal: false
    };
  }

  static getDerivedStateFromProps(props) {
    return {
      guests: props.guests,
      guestGroup: props.guestGroup
    };
  }

  removeGuestFromGroup = guest => {
    _.remove(this.state.guestGroup.guestgroups, guest);
    const newGuestIds = this.state.guestGroup.guestgroups.map(guestgroup => guestgroup.id);
    this.props.updateGuestGroup({
      id: this.state.guestGroup.id,
      name: this.state.guestGroup.name,
      guestIds: newGuestIds
    });
    this.forceUpdate();
  };

  addGuestsToGroup = guests => {
    this.state.guestGroup.guestgroups.push(...guests);
    this.props.updateGuestGroup({
      id: this.state.guestGroup.id,
      name: this.state.guestGroup.name,
      guestIds: this.state.guestGroup.guestgroups.map(
        guestgroup => guestgroup.id
      )
    });
    this.forceUpdate();
  };

  guestGroupMembersTableColumns = [
    {
      id: "guestName",
      label: "Name",
      sortOverride:`contact.firstName`,
      isString:true,
      isBaseColumn: true,
      dataField: 'contact.firstName',
      secondaryDataField: 'contact.lastName',
      cellValueCalculator: guest =>
      <NavLink exact to={`/admin/guestSettings/${guest.id}`}>
          <span>{`${guest.contact.firstName} ${guest.contact.lastName}`}</span>
      </NavLink>
        
    },
    {
      id: "company",
      label: "Company",
      isString: true,
      cellValueCalculator: guest => guest.contact.company.name
    },
    {
      id: "email",
      label: "Email",
      isString: true,
      cellValueCalculator: guest => guest.contact.email
    },
    {
      id: "pipelinePermission",
      label: "Pipeline",
      isString: true,
      cellValueCalculator: guest => guest.pipelinePermission ? guest.pipelinePermission.value : "None"
    },
    {
      id: "portfolioPermission",
      label: "Portfolio",
      isString: true,
      cellValueCalculator: guest => guest.portfolioPermission ? guest.portfolioPermission.value : "None"
    },
    {
      id: "actions",
      actions: true,
      blankLabel: true,
      cell: ({ data }) => (
        <TableCell style={{ textAlign: "right" }}>
          <NewButton onClick={() => this.setState({ guestToRemove: data, isRemoveGuestModalOpen: true })}>
            <DeleteIcon className="icon delete" />
          </NewButton>
        </TableCell>
      )
    }
  ];

  render() {
    return (
      <Fragment>
        <AddGuestGroupMembersModal
          guests={this.state.guestGroup.guestgroups === undefined ? [] : this.state.guests.filter(guest => !this.state.guestGroup.guestgroups.some(guestgroup => guestgroup.id === guest.id))}
          isOpen={this.state.showAddMembersModal}
          closeModal={() => this.setState({ showAddMembersModal: false })}
          save={guests => this.addGuestsToGroup(guests)}
        />
        <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={16} style={{ marginTop: 10, marginBottom: 10 }}>
          <HeaderLeftContainer item xs={8}>
            <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={8}>
              <Grid item>
                <div className="title-component">
                  GUEST PERMISSIONS / {this.state.guestGroup.name && this.state.guestGroup.name.toUpperCase()}
                </div>
              </Grid>
              <Grid item>
                <NewButton variant="contained" onClick={() => this.setState({ showAddMembersModal: true })}>
                  <AddIcon />
                  <span>Add Members</span>
                </NewButton>
              </Grid>
            </Grid>
          </HeaderLeftContainer>
          <Grid item xs={4} style={{ textAlign: "right" }}>
            <NavLink exact to="/admin/guestPermissions">
              <NewButton variant="contained">Go Back</NewButton>
            </NavLink>
          </Grid>
        </Grid>

        <EnhancedTable
          columnDefinitions={this.guestGroupMembersTableColumns}
          rows={this.state.guestGroup.guestgroups}
          noRowsMessage="No Guests have been added to this group"
          sortable
          orderBy={this.guestGroupMembersTableColumns[0]}
          shouldHideConfig
          shouldHideExport
        />

        <SimpleConfirmDialog
          title="Confirm Delete"
          message={this.state.guestToRemove === undefined ? "" : <div>You are about to remove {this.state.guestToRemove.contact.firstName} {this.state.guestToRemove.contact.lastName} from this guest group.  This will not affect his/her current access to any assigned deals.<br /><br />Are you sure you want to do this?</div>}
          noText="NO"
          yesText="YES, DELETE"
          modalOpen={this.state.isRemoveGuestModalOpen}
          handleNo={() => this.setState({ isRemoveGuestModalOpen: false })}
          handleYes={() => {
            this.removeGuestFromGroup(this.state.guestToRemove);
            this.setState({ isRemoveGuestModalOpen: false });
          }}
        />
      </Fragment>
    );
  }
}

function mapStateToProps({ guest, guestGroup, authentication }) {
  return {
    guests: guest.guests,
    guestGroup: guestGroup.guestGroup,
    authentication
  };
}

export default compose(
  connect(
    mapStateToProps,
    {
      getAllGuests,
      getGuestGroupById,
      updateGuestGroup
    }
  )
)(GuestPermissionsPage);
